<template>
  <form>
    <div class="row">
    <h4 class="card-title"></h4>
    <div class="col-lg-12">
      <div class="border-bottom border-light">
        <p class="medium">{{$t('medium_grant_cn.document_upload_concept_technical_proposal')}}</p>
        <div class="inline my-2">
        <a :href="downloadFiles[0][$i18n.locale]" class="btn btn-simple btn-primary" :disabled="GrantForm.disableConcept">
                {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
              </a>
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnConceptTechnicalProposal" type="cn" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnConceptTechnicalProposal" :size-limit="GrantForm.fileSizeLimit" section="technical.cnConceptTechnicalProposal"></upload-file>
            </div>

        <!--<div class="form-group file-group" v-for="(field, index) in GrantForm.model.cndocuments.cnOtherDocs" :key="'custom_field_' + index">
                            <input class="msd-field-title" type="text" v-model="field.title" />
                            <upload-file
                                v-if="GrantForm.initialized"
                                :key="'custom_field_upload_' + index"
                                v-model="GrantForm.files.technical[field.key]"
                                class="upload-file"
                                :section="'concept.' + field.key"
                                :file-data="GrantForm.files.technical[field.key]"
                                :is-editable="GrantForm.isEditable"
                                :model-name="'MonitoringReport'"
                                :size-limit="GrantForm.fileSizeLimit"
                                @file="fileAdded"
                            >
                            </upload-file>
                            <span class="msd-remove-item tim-icons icon-trash-simple ml-4" @click="removeSupportField(GrantForm.model.cndocuments, index)" v-if="GrantForm.isEditable"></span>
                        </div>
                        <base-button
                            v-if="GrantForm.isEditable"
                            type="primary"
                            class=""
                            @click="addNewSupportingDocument(GrantForm.model.cndocuments,'concept_technical')"
                            >
                           <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
                        </base-button>-->
      </div>

          <!--<div class="border-bottom border-light">
            <div class="inline my-2">
            <p class="medium">{{$t('medium_grant_cn.document_upload_esms_questionnaire')}}</p>
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnEsmsQuestionnaire" type="cn" :is-editable="GrantForm.isEditable" :file-data="GrantForm.files.technical.cnEsmsQuestionnaire" :size-limit="GrantForm.fileSizeLimit" section="technical.cnEsmsQuestionnaire"></upload-file>
            </div>
          </div>-->

          <div class="border-bottom border-light">
            <div class="inline my-2">
            <p class="medium">{{$t('medium_grant_cn.document_upload_applicant_declaration')}}</p>
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnApplicantDeclaration" type="cn" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnApplicantDeclaration" :size-limit="GrantForm.fileSizeLimit" section="technical.cnApplicantDeclaration"></upload-file>
            </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
            <p class="medium">{{$t('medium_grant_cn.document_upload_coapplicant_declaration')}}</p>
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.cnCoapplicantDeclarationDocument" type="cn" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.cnCoapplicantDeclarationDocument" :size-limit="GrantForm.fileSizeLimit" section="technical.cnCoapplicantDeclarationDocument"></upload-file>
            </div>
          </div>
          
      
      
    </div>
    <div class="col-lg-12 mt-2">
                  <!-- additional docs -->
          <h4 class="card-title">Addition Documents</h4>
            <div class="inline my-2 form-group file-group border-light" v-for="(item, index) in GrantForm.model.cndocuments.cnConceptOtherDocs" :key="'result_'+index" style="width:100%">
              <div style="width:50%">
               <input class="" type="text" :disabled="GrantForm.disableConcept" v-model="item.result" />
              </div>
              <div class="mt-2 ml-2">
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.technical['cnConceptOtherDocs' + (index+1)]"
                  class="upload-file"
                  :file-data="GrantForm.files.technical['cnConceptOtherDocs' + (index+1)]"
                  :is-editable="GrantForm.isEditable && !GrantForm.disableConcept"
                  :section="'technical.cnConceptOtherDocs' + (index + 1)"
                  type="cn"
                  
                  >
                </upload-file>
                <!--@file="fileAdded"-->
              </div>
              <span class="msd-remove-item tim-icons icon-trash-simple ml-4 deleterow" @click="removeSupportField(GrantForm.model.cndocuments.cnConceptOtherDocs, index)" v-if="GrantForm.isEditable && !GrantForm.disableConcept"></span>
            </div>

        <base-button
          type="primary"
          @click.native="addOtherDocument"
          class=""
          :disabled="GrantForm.disableConcept"
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
        </base-button>
      </div>
       </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import {BaseCheckbox, BaseRadio} from 'src/components/index';
  import {EventBus} from '@/event-bus.js';

  export default {
    data() {
      return {
        GrantForm,
        orgCoApplicants: [],
        downloadFiles: [
          {
            en: '/files/en/MG/CN/Region/'+GrantForm.regionId+'/technical_template.docx',
            fr: '/files/fr/MG/CN/Region/'+GrantForm.regionId+'/technical_template.docx'
          },
        ]
      }
    },
    components: {
      BaseCheckbox,
      BaseRadio
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      addOrgCoApplicant() {
        this.orgCoApplicants.push({
          orgName: '',
          shortDesc: '',
          role: '',
          budget: ''
        })
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      addOtherDocument()
      {
        if (!GrantForm.model.cndocuments.cnConceptOtherDocs)
        {
          GrantForm.model.cndocuments.cnConceptOtherDocs = [];
        }

        GrantForm.model.cndocuments.cnConceptOtherDocs.push({});
        this.$forceUpdate();
      },

      /*addOtherEsmsDocument()
      {
        if (!GrantForm.model.cndocuments.cnEsmsOtherDocs)
        {
          GrantForm.model.cndocuments.cnEsmsOtherDocs = [];
        }

        GrantForm.model.cndocuments.cnEsmsOtherDocs.push({});
        this.$forceUpdate();
      },*/
      addNewSupportingDocument(subgroup, group_index)
            {
                const last_index = subgroup.cnOtherDocs.length;

                subgroup.cnOtherDocs.push({
                    key: 'support_document_custom_' + group_index + '_' + last_index + '_' + (+new Date()),
                    title: '',
                });

                this.$forceUpdate();
            },
            removeSupportField(subgroup, index)
            {
                if (confirm(this.$t('monitoring.confirm__remove_field')))
                {
                    subgroup.splice(index, 1);
                }
            },
      fileAdded(file) {
                EventBus.$emit('wizard-save-progress');
      }
    },
    mounted() {
      if (GrantForm.model.technical.orgCoApplicants) {
        this.orgCoApplicants = GrantForm.model.technical.orgCoApplicants;
      }
    },
    watch: {
      orgCoApplicants(value) {
        GrantForm.model.technical.orgCoApplicants = value;
      }
    },
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }

  .inline{
    display: flex;
  justify-content: space-between;
  }

  .inline p{
width: 50%;
margin-right: 10px;
  }
</style>
